export class AccordionHTMLElement extends HTMLElement {

    private accordionBehaviour: boolean;

    constructor() {
        super();
        this.accordionBehaviour = true;
    }

    static get observedAttributes(): string[] {
        return ['data-accordion-behaviour'];
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (name !== 'data-accordion-behaviour') {
            return;
        }
        this.accordionBehaviour = newValue === 'on';
    }

    public connectedCallback(): void {
        const element = <HTMLElement>this;
        element.addEventListener('click', oEvent => {
            const clickElement = oEvent.composedPath()[0] as HTMLElement;
            const header = clickElement.closest('.accordion-item-header');
            if (header) {
                oEvent.stopPropagation();
                const itemElement = clickElement.closest('.accordion-item');
                const isActive = itemElement.hasAttribute('data-item-active');
                if (this.accordionBehaviour) {
                    const sibling = itemElement.closest('.accordion-items').children;
                    for (const item of Array.from(sibling)) {
                        item.removeAttribute('data-item-active');
                        item.querySelector('.accordion-item-header').ariaExpanded = "false";
                        item.querySelector('.accordion-item-body').ariaHidden = "true";
                    }
                }
                if (isActive) {
                    itemElement.removeAttribute('data-item-active');
                    itemElement.querySelector('.accordion-item-body').ariaHidden = "true";
                    header.ariaExpanded = "false";
                } else {
                    itemElement.setAttribute('data-item-active', 'true')
                    itemElement.querySelector('.accordion-item-body').ariaHidden = "false";
                    header.ariaExpanded = "true";
                }
            }
        });
    }
}
